import { getGridBooleanOperators, getGridDateOperators, getGridNumericOperators, getGridStringOperators } from '@mui/x-data-grid';
/**
 * Filters out unwanted operators from the default MUI DataGrid filter operators
 * Removes: "does not contain" and "does not equal" filters
 */
var filterUnwantedOperators = function (operators) {
    return operators.filter(function (op) {
        // Remove "does not contain"
        if (op.value === 'doesNotContain')
            return false;
        // Remove "does not equal"
        if (op.value === 'doesNotEqual')
            return false;
        return true;
    });
};
/**
 * Get filtered string operators (contains, equals, starts with, ends with, is empty, is not empty)
 * Removes: does not contain, does not equal
 */
export var getFilteredStringOperators = function () {
    return filterUnwantedOperators(getGridStringOperators());
};
/**
 * Get filtered numeric operators (=, !=, >, >=, <, <=, is empty, is not empty)
 * Removes: does not equal (!=)
 */
export var getFilteredNumericOperators = function () {
    return filterUnwantedOperators(getGridNumericOperators());
};
/**
 * Get filtered date operators (is, not, after, on or after, before, on or before, is empty, is not empty)
 * Removes: is not
 */
export var getFilteredDateOperators = function () {
    return filterUnwantedOperators(getGridDateOperators());
};
/**
 * Get filtered boolean operators (is)
 */
export var getFilteredBooleanOperators = function () {
    return filterUnwantedOperators(getGridBooleanOperators());
};
